(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tapo-upsell-product-showcase1"] && !Shopify.designMode) return;
  try {
    
  // MODIFIED START: View more / View less behaviour
  function initTapoProductToggles(root) {
    const scope = root || document;

    scope.querySelectorAll('.tapo-product-list').forEach((section) => {
      const toggle = section.querySelector('[data-product-toggle]');
      const toggleLabel = section.querySelector('[data-product-toggle-label]');
      const collapsibleProducts = Array.from(section.querySelectorAll('[data-collapsible-product]'));

      if (!toggle || !toggleLabel || collapsibleProducts.length === 0 || toggle.dataset.productToggleReady === 'true') return;

      toggle.dataset.productToggleReady = 'true';

      const setExpanded = (expanded) => {
        collapsibleProducts.forEach((product) => {
          product.hidden = !expanded;
        });

        toggle.setAttribute('aria-expanded', String(expanded));
        toggleLabel.textContent = expanded
          ? toggle.dataset.viewLessLabel
          : toggle.dataset.viewMoreLabel;
      };

      toggle.addEventListener('click', () => {
        setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
      });

      section.addEventListener('shopify:block:select', (event) => {
        if (event.target.matches('[data-collapsible-product]')) setExpanded(true);
      });

      setExpanded(false);
    });
  }
  // MODIFIED END: View more / View less behaviour

  function initTapoGiftCarousels(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-gift-carousel]').forEach((carousel) => {
      if (carousel.dataset.giftCarouselReady === 'true') return;
      const track = carousel.querySelector('[data-gift-track]');
      const slides = Array.from(carousel.querySelectorAll('[data-gift-slide]'));
      const next = carousel.querySelector('[data-gift-next]');
      if (!track || slides.length < 2 || !next) return;
      carousel.dataset.giftCarouselReady = 'true';
      let index = 0;
      const show = (nextIndex) => {
        index = (nextIndex + slides.length) % slides.length;
        track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
      };
      next.addEventListener('click', () => show(index + 1));
    });
  }

  initTapoGiftCarousels(document);
  // MODIFIED START: initialise collapsible products on page load and Theme Editor reload
  initTapoProductToggles(document);
  document.addEventListener('shopify:section:load', (event) => {
    initTapoGiftCarousels(event.target);
    initTapoProductToggles(event.target);
  });
  // MODIFIED END: initialise collapsible products on page load and Theme Editor reload

  } catch(e) { console.error(e); }
})();
})();
